import React from 'react';
import { motion } from 'framer-motion';
import { 
  MapPin, 
  Phone, 
  Mail, 
  Globe, 
  Facebook, 
  Instagram, 
  Youtube
} from 'lucide-react';
import './Footer.css';
import logo from '../assets/UNIFAP-1.png';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-background">
      </div>

      <div className="footer-container">
        <div className="footer-content">
          {/* Logo e Informações */}
          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="footer-logo">
              <div className="logo-container">
                <img src={logo} alt="Logo" className="logo-icon-logo"/>
              </div>
              <div>
                <h3>UNIFAP</h3>
                <p>Portal de Serviços</p>
              </div>
            </div>
            <p className="footer-description">
              Universidade Federal do Amapá - Conectando conhecimento e inovação na Amazônia. 
              Acesse nossos serviços de forma rápida e organizada.
            </p>
            <div className="footer-social">
              <a href="#" className="social-link">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-link">
                <Youtube size={20} />
              </a>
              <a href="#" className="social-link">
                <Globe size={20} />
              </a>
            </div>
          </motion.div>

          {/* Links Rápidos */}
          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4>Links Rápidos</h4>
            <ul className="footer-links">
              <li><a href="#inicio">Início</a></li>
              <li><a href="#servicos">Serviços</a></li>
              <li><a href="#sobre">Sobre a UNIFAP</a></li>
              <li><a href="#contato">Contato</a></li>
              <li><a href="/login">Área do Aluno</a></li>
              <li><a href="/login">Área do Servidor</a></li>
            </ul>
          </motion.div>

          {/* Serviços */}
          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h4>Serviços</h4>
            <ul className="footer-links">
              <li><a href="#">Matrícula</a></li>
              <li><a href="#">Histórico Escolar</a></li>
              <li><a href="#">Calendário Acadêmico</a></li>
              <li><a href="#">Biblioteca Digital</a></li>
              <li><a href="#">SIGAA</a></li>
              <li><a href="#">Protocolo</a></li>
            </ul>
          </motion.div>

          {/* Contato */}
          <motion.div 
            className="footer-section"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
          >
            <h4>Contato</h4>
            <div className="contact-info">
              <div className="contact-item">
                <MapPin size={20} />
                <div>
                  <p>Rodovia Juscelino Kubitschek, Km 02</p>
                  <p>Macapá - AP, 68903-419</p>
                </div>
              </div>
              <div className="contact-item">
                <Phone size={20} />
                <div>
                  <p>(96) 3312-1700</p>
                  <p>(96) 3312-1701</p>
                </div>
              </div>
              <div className="contact-item">
                <Mail size={20} />
                <div>
                  <p>gabinete@unifap.br</p>
                  <p>portal@unifap.br</p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Linha de Separação */}
        <div className="footer-divider"></div>

        {/* Copyright */}
        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <p>&copy; 2025 Universidade Federal do Amapá. Todos os direitos reservados.</p>
          <div className="footer-bottom-links">
            <a href="#">Política de Privacidade</a>
            <a href="#">Termos de Uso</a>
            <a href="#">Acessibilidade</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 